module.exports = __webpack_public_path__ + "img/strategic-4.3a2f803e.png";